$(document).ready(function () {
    function showFullTabContent() {
        const productDetailInfo = document.querySelector('.product-detail__info--tabcontent')
        if (productDetailInfo) {
            productDetailInfo.classList.add('show-full')

            const productDetailInfoMore = document.querySelector('.product-detail__info-more')
            if (productDetailInfoMore) {
                const more = productDetailInfoMore.querySelector('.product-detail__info-more--more')
                more && more.classList.remove('active')

                const collapse = productDetailInfoMore.querySelector('.product-detail__info-more--collapse')
                collapse && collapse.classList.add('active')
            }
        }
    }

    // function requestGeolocation() {
    //     // Lấy vị trí của client
    //     if (navigator.geolocation) {
    //         navigator.geolocation.getCurrentPosition(function (position) {
    //             var latitude = position.coords.latitude;
    //             var longitude = position.coords.longitude;
    //
    //             var clientPosition = {
    //                 latitude: latitude,
    //                 longitude: longitude
    //             };
    //
    //             // Lưu vị trí vào cookie
    //             setCookie("clientPosition", JSON.stringify(clientPosition));
    //
    //             var expiration = new Date();
    //             // Thiết lập thời gian hết hạn là 1 giờ kể từ hiện tại
    //             expiration.setHours(expiration.getHours() + 1);
    //             setCookie("clientPositionExpiration", expiration);
    //
    //             showPosition(clientPosition);
    //         }, showError);
    //     } else {
    //         console.log("Geolocation is not supported by this browser.");
    //     }
    // }

    // function setCookie(name, value, days) {
    //     var expires = "";
    //     if (days) {
    //         var date = new Date();
    //         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    //         expires = "; expires=" + date.toUTCString();
    //     }
    //     document.cookie = name + "=" + (value || "") + expires + "; path=/";
    // }
    //
    // function getCookie(name) {
    //     var nameEQ = name + "=";
    //     var ca = document.cookie.split(';');
    //     for (var i = 0; i < ca.length; i++) {
    //         var c = ca[i];
    //         while (c.charAt(0) === ' ') {
    //             c = c.substring(1, c.length);
    //         }
    //         if (c.indexOf(nameEQ) === 0) {
    //             return c.substring(nameEQ.length, c.length);
    //         }
    //     }
    //     return null;
    // }
    //
    // function deleteCookie(name) {
    //     document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    // }

    // function showPosition(position) {
    //     var latitude = position.latitude;
    //     var longitude = position.longitude;
    //
    //     console.log("Latitude: " + latitude);
    //     console.log("Longitude: " + longitude);
    // }
    //
    // function showError(error) {
    //     switch (error.code) {
    //         case error.PERMISSION_DENIED:
    //             console.log("User denied the request for Geolocation.");
    //             break;
    //         case error.POSITION_UNAVAILABLE:
    //             console.log("Location information is unavailable.");
    //             break;
    //         case error.TIMEOUT:
    //             console.log("The request to get user location timed out.");
    //             break;
    //         case error.UNKNOWN_ERROR:
    //             console.log("An unknown error occurred.");
    //             break;
    //     }
    // }

    // function showGeolocationPopup() {
    //     window.setOverlayBody()
    //     window.showPopup('popup-confirm-location')
    // }

    // $(".product-detail__detail--left__main .slider-single").slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     asNavFor: ".product-detail__detail--left__thumb",
    //     prevArrow: $('.product-detail__arrow-left'),
    //     nextArrow: $('.product-detail__arrow-right'),
    // });
    // $(".product-detail__detail--left__thumb").slick({
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     asNavFor: ".product-detail__detail--left__main .slider-single",
    //     focusOnSelect: true,
    //     arrows: false
    // });

    $('.product-detail__detail--left__main .slider-single').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: ".product-detail__detail--left__thumb",
        prevArrow: $('.product-detail__arrow-left'),
        nextArrow: $('.product-detail__arrow-right'),
    });

    $('.product-detail__detail--left__main-mobile .slider-single').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    });

    $('.slider-product-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        // fade: true
    });

    const productDetailThumbItems = document.querySelectorAll('.product-detail-thumb-item')
    if (productDetailThumbItems.length > 0) {
        // let countItem = (productDetailThumbItems.length <= 4) ? (productDetailThumbItems.length - 1) : 4

        $('.product-detail__detail--left__thumb').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.product-detail__detail--left__main .slider-single',
            dots: false,
            // centerMode: true,
            arrows: false,
            focusOnSelect: true
        });
    }

    $('.list-product-relate').slick({
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: $('.product-relate__arrow-left'),
        nextArrow: $('.product-relate__arrow-right'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    function collapseDescription() {
        const productDetailInfoTabContent = document.querySelector('.product-detail__info--tabcontent')
        if (productDetailInfoTabContent) {
            productDetailInfoTabContent.classList.remove('show-full')

            const productDetailInfoMore = document.querySelector('.product-detail__info-more')
            if (productDetailInfoMore) {
                const more = productDetailInfoMore.querySelector('.product-detail__info-more--more')
                more && more.classList.add('active')

                const collapse = productDetailInfoMore.querySelector('.product-detail__info-more--collapse')
                collapse && collapse.classList.remove('active')
            }
        }
    }

    function showGallery(imgSrc, targetParent) {
        const gallery = targetParent.querySelector('.gallery-global')
        if (!gallery) return;
        const itemGalleryActive = gallery.querySelector(`a[href='${imgSrc}']`)
        if (!itemGalleryActive) return;
        itemGalleryActive.click()
    }

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('tablinks')) {
            const parentTab = e.target.closest('.product-detail__info--tab')
            if (parentTab) {
                const tabActiveCurrent = parentTab.querySelector('.active')
                tabActiveCurrent && tabActiveCurrent.classList.remove('active')
            }
            e.target.classList.add('active')
            // const parentWrapper = parentTab.parentElement
            // const dataTabTitle = e.target.getAttribute('data-tab-title')
            // const tabContents = parentWrapper.querySelectorAll('.tabcontent')

            // if (tabContents.length > 0) {
            //     tabContents.forEach(tabContent => {
            //         tabContent.classList.remove('active')

            //         if (tabContent.getAttribute('data-tab-content') == dataTabTitle) {
            //             tabContent.classList.add('active')
            //         }
            //     })
            // }

            // collapseDescription()
            showFullTabContent()
        }

        if (e.target.classList.contains('tablinks')) {
            const parentTab = e.target.closest('.tab')

            if (parentTab) {
                const tabs = parentTab.querySelectorAll('.tablinks')

                if (tabs.length > 0) {
                    tabs.forEach(tab => {
                        tab.classList.remove('active')
                    })
                }
            }
            e.target.classList.add('active')
            const parentWrapper = parentTab.parentElement
            const dataTabTitle = e.target.getAttribute('data-tab-title')
            const tabContents = parentWrapper.querySelectorAll('.tabcontent')

            if (tabContents.length > 0) {
                tabContents.forEach(tabContent => {
                    tabContent.classList.remove('active')

                    if (tabContent.getAttribute('data-tab-content') == dataTabTitle) {
                        tabContent.classList.add('active')
                    }
                })
            }

            collapseDescription()
        }

        if (e.target.classList.contains('variant-item') || e.target.closest('.variant-item')) {
            let target = null
            if (e.target.classList.contains('variant-item')) {
                target = e.target
            } else {
                target = e.target.closest('.variant-item')
            }


            const parent = target.closest('.product-detail__detail--right__variants')
            if (parent) {
                const activeCurrent = parent.querySelector('.active')
                activeCurrent && activeCurrent.classList.remove('active')

                target.classList.add('active')
            }
        }

        if (e.target.classList.contains('product-detail__info-more--more') || e.target.closest('.product-detail__info-more--more')) {
            // let target = null
            // if (e.target.classList.contains('product-detail__info-more--more')) {
            //     target = e.target
            // } else {
            //     target = e.target.closest('.product-detail__info-more--more')
            // }

            showFullTabContent()
        }

        if (e.target.classList.contains('product-detail__info-more--collapse') || e.target.closest('.product-detail__info-more--collapse')) {
            // let target = null
            // if (e.target.classList.contains('product-detail__info-more--collapse')) {
            //     target = e.target
            // } else {
            //     target = e.target.closest('.product-detail__info-more--collapse')
            // }

            collapseDescription()
        }

        if (e.target.classList.contains('zoom') || e.target.closest('.zoom')) {
            const leftMain = e.target.closest('.product-detail__detail--left__main')
            if (leftMain) {
                const slideMainActive = leftMain.querySelector('.slick-active')
                if (slideMainActive) {
                    const imgTag = slideMainActive.querySelector('img')
                    const imgSrc = imgTag.getAttribute('src')
                    const targetParent = slideMainActive.closest('.product-detail')
                    if (targetParent) {
                        showGallery(imgSrc, targetParent)
                    }
                }
            }
        }

        // if (e.target.classList.contains('mua_tai_nha_thuoc')) {
        //     if (storedPosition && storedExpiration) {
        //         //
        //         console.log('Exsist cookie');
        //     } else {
        //         showGeolocationPopup()
        //     }
        // }

        // if (e.target.classList.contains('not-allow-location')) {
        //     window.removeOverlayBody()
        //     window.hidePopup()
        //
        //     deleteCookie("clientPosition");
        //     deleteCookie("clientPositionExpiration");
        // }
        //
        // if (e.target.classList.contains('allow-location')) {
        //     window.removeOverlayBody()
        //     window.hidePopup()
        //
        //     // Kiểm tra xem đã có vị trí của client trong cookie hay chưa
        //     var storedPosition = getCookie("clientPosition");
        //     var storedExpiration = getCookie("clientPositionExpiration");
        //
        //     if (storedPosition && storedExpiration) {
        //         var position = JSON.parse(storedPosition);
        //         var expiration = new Date(storedExpiration);
        //
        //         // Kiểm tra xem dữ liệu vị trí đã hết hạn chưa
        //         if (expiration > new Date()) {
        //             showPosition(position);
        //         } else {
        //             // Xóa dữ liệu vị trí đã hết hạn
        //             deleteCookie("clientPosition");
        //             deleteCookie("clientPositionExpiration");
        //             requestGeolocation();
        //         }
        //     } else {
        //         requestGeolocation();
        //     }
        // }

        // if (e.target.classList.contains('btn-add-to-card')) {
        //     // console.log(e.target)
        //
        //     const popupAtc = document.querySelector('.popup-atc')
        //     if (popupAtc) {
        //         // console.log(popupAtc);
        //         window.setOverlayBody()
        //         popupAtc.classList.add('active')
        //     }
        // }

        // if (e.target.classList.contains('update-address__head--close') || e.target.closest('.update-address__head--close')) {
        //     window.removeOverlayBody()
        //     window.hidePopup()
        // }

        // if (e.target.classList.contains('update-address-btn')) {
        //     window.setOverlayBody()
        //     window.showPopup('popup-update-address')
        // }
    })

    let eleStoreWrapper = $('#nhan_tai_nha_thuoc .store-list');
    // if (typeof STORE_LOADER == 'string') {
        // eleStoreWrapper.html(STORE_LOADER);

        // $('.search-store-map.in-product-detail').on('click', function () {
        //     console.log('here click');
        //     let dataListStore = getItemWithExpiration('listStoreInProductDetail');

        //     if (!dataListStore) {
        //         // eleStoreWrapper.html(STORE_LOADER);
        //     }
        // });

    //     $('#loadingPage').remove();
    // }

    let getStores = function (action, params) {
        let dataListStore = getItemWithExpiration('listStoreInProductDetail');
        let productIdValue = null
        const productId = document.querySelector(`input[name="product_id"]`)
        if (productId) {
            productIdValue = productId.value
        }

        if (dataListStore && (productIdValue == dataListStore.custom_value)) {
            eleStoreWrapper.html(dataListStore.value);
        } else {
            eleStoreWrapper.html(STORE_LOADER || 'loading...');
            $.ajax({
                'url': action,
                'method': 'POST',
                'data': JSON.stringify(params),
                'headers': {
                    'Content-Type': 'application/json'
                },
            }).done(function (response) {
                eleStoreWrapper.html(response);
                setItemWithExpiration('listStoreInProductDetail', response, 1440, productIdValue);
            })
        }

        $('.update-list-store').removeClass('d-none')
    }

    $('.update-list-store').on('click', function () {
        const formSearch = $('#mainFormSearch.in-product-detail')
        let productIdValue = null
        const productId = document.querySelector(`input[name="product_id"]`)
        if (productId) {
            productIdValue = productId.value
        }

        eleStoreWrapper.html(STORE_LOADER || 'loading...');
        let params = {
            'lat': formSearch.find('[name="lat"]').val(),
            'long': formSearch.find('[name="long"]').val(),
        }
        
        $.ajax({
            'url': formSearch.attr('data-action'),
            'method': 'POST',
            'data': JSON.stringify(params),
            'headers': {
                'Content-Type': 'application/json'
            },
        }).done(function (response) {
            eleStoreWrapper.html(response);
            setItemWithExpiration('listStoreInProductDetail', response, 1440, productIdValue);
        })
    })

    $('#mainFormSearch.in-product-detail').on('submit', function (e) {
        e.preventDefault();
        getStores($(this).attr('data-action'), {
            'lat': $(this).find('[name="lat"]').val(),
            'long': $(this).find('[name="long"]').val(),
        });
    })

    let form_update_location = $('#form-update-location');
    if (form_update_location) {
        form_update_location.validate();
        form_update_location.on('submit', function (e) {
            e.preventDefault();

            if (!form_update_location.valid()) {
                return;
            }

            window.removeOverlayBody()
            window.hidePopup()

            getStores($(this).attr('data-action'), {
                'province_id': $(this).find('[name="provinceId"]').val(),
                'district_id': $(this).find('[name="districtId"]').val(),
                'ward_id': $(this).find('[name="wardId"]').val(),
            });
        })
    }

    if (window.innerWidth < 768) {
        const footerLine = document.querySelector('.footer-line')
        if (footerLine) {
            const formAddToCart = document.querySelector('.form-add-to-cart')
            if (formAddToCart) {
                const heightRealFormATC = formAddToCart.clientHeight
                footerLine.style.marginBottom = heightRealFormATC + 'px'
            }

        }
    }
});